import { Constant } from '../constant';
import { CopyProperties } from '../decorator/copy-properties.decorator';
@CopyProperties()
export class Page {
    code: any;
    totalItems: any;
    totalPage: any;
    pageSize: any;
    pageBefore: any
    pageCurrent: any;
    pages: any;
    functions: any;
    loading: boolean = false;
    constructor(
        param?: any
    ) {
        this.setValue(param);
    }
    setValue(params: any) {
        if (params) {
            this.code = params.code || 1;
            this.pages = [];
            this.totalItems = params.total || params.totalItems;
            this.totalPage = Math.ceil(this.totalItems / params.pageSize) || 1;
            this.pageSize = params.pageSize || Constant.const_pagerSize_default;
            this.pageCurrent = params.pageCurrent || 1;
            this.setPages();
            if (this.pageCurrent === 1) {
                this.first();
            }
            this.functions = params.functions ? params.functions  :  {
                getData: params.func
            }
        } else {
            this.setAllNull();
        }
    }
    setAllNull() {
        this.code = 1;
        this.totalPage = 1;
        this.pageSize = Constant.const_pagerSize_default;
        this.pageCurrent = 1;
        this.pageBefore = 1;
        this.pages = [1];
    }
    public changePage(number) {
        this.pageBefore = this.pageCurrent;
        if (number > 1 && number < this.totalPage) {
            this.pageCurrent = number;
        } else if (number > 1 && number >= this.totalPage) {
            this.pageCurrent = this.totalPage;
        } else if (number <= 1) {
            this.pageCurrent = 1;
        } 
        this.loading = true;
        return this.functions.getData();
    }
    public checkNext() {
        // if (this.pages[this.pages.length-1] + 1 < this.totalPage) {
        //     return true;
        // } else {
        //     return false;
        // }
        if (this.pageCurrent < this.totalPage) {
            return true;
        } else return false;
    }
    public next() {
        this.pageBefore = this.pageCurrent;
        if (!this.checkNext()) {
            return;
        }
        // this.pageCurrent = this.pages[this.pages.length-1];
        this.pageCurrent++;
        this.loading = true;
        return this.functions ? this.functions.getData() : false;
    }
    public checkPrevious() {
        if (this.pageCurrent > 1) {
            return true;
        } else return false;
    }
    public previous() {
        this.pageBefore = this.pageCurrent;
        if (!this.checkPrevious()) {
            return;
        }
        this.pageCurrent--;
        this.loading = true;
        return this.functions ? this.functions.getData() : false;
    }
    public first() {
        this.pageBefore = this.pageCurrent;
        this.pageCurrent = 1;
        if (this.totalPage > 4) {
            this.setPages();
        } else {
            this.pages = [];
            for (let i = 0 ; i < this.totalPage; i++) {
                this.pages.push(i+1);
            }
        }
        this.loading = true;
        return this.functions ? this.functions.getData() : false;
    }
    setPages() {
        this.pages = [this.pageCurrent];
        let before = 2, valueBefore = 1, after = 2, valueAfter = 1;
        for (let i = 0 ; i < 5; i++) {
            if (before > 0) {
                if (this.pageCurrent - valueBefore > 0) {
                    before--;
                    this.pages.unshift(this.pageCurrent - valueBefore)
                    valueBefore++;
                } else {
                    after+= before;
                    before = 0;
                }
            }
            if (after > 0){
                if (this.pageCurrent + valueAfter <= this.totalPage) {
                    after--;
                    this.pages.push(this.pageCurrent + valueAfter)
                    valueAfter++;
                } else {
                    before+= after;
                    after = 0;
                }
            }
        }
        this.loading = false;
        this.pageBefore = this.pageCurrent;
    }
    public last() {
        this.pageBefore = this.pageCurrent;
        this.pageCurrent = this.totalPage;
        this.loading = true;
        return this.functions ? this.functions.getData() : false;
    }
}